import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Aula, Alumno} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiAulasService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** aulas ***/

  getAulas(): Promise<Aula[]> {
    const url = `${this.apiUrl}aulas`;
    return firstValueFrom(this.http.get<Aula[]>(url))
  }
  getAlumnosAula(aula: number): Promise<Alumno[]> {
    const url = `${this.apiUrl}aulas/${aula}`;
    return firstValueFrom(this.http.get<Alumno[]>(url))
  }
  addAula(datos: Aula): Promise<any> {
    const url = `${this.apiUrl}aulas`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  updateAula(datos: Aula): Promise<void> {
    const url = `${this.apiUrl}aulas/${datos.numeroAula}`;
    return firstValueFrom(this.http.put<void>(url, datos))
  }
  eliminarAula(numeroAula: number): Promise<any> {
    const url = `${this.apiUrl}aulas/${numeroAula}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
